import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { Provider } from 'react-redux';
import makeStore from './redux';
import Header from './components/Header';
import Footer from './components/Footer';
import './App.scss';

const store = makeStore();

const MobileTokenGenerator = lazy(() => import('./pages/mobileTokenGenerator'));
const MobileTokenSuccess = lazy(() => import('./pages/mobileTokenSuccess'));
const MobileTokenFailure = lazy(() => import('./pages/mobileTokenFailure'));

function LoadingMessage() {
  return "I'm loading...";
}

function lazyComponent(Component) {
  return props => (
    <Suspense fallback={<LoadingMessage />}>
      <Component {...props} />
    </Suspense>
  );
}

// TODO add negative margin to fix the footer - https://css-tricks.com/couple-takes-sticky-footer/

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Header />

        <div className="App">
          <Switch>
            <Route exact path="/mobile-token-generator" component={lazyComponent(MobileTokenGenerator)} />
            <Route path="/mobile-token-generator/success" component={lazyComponent(MobileTokenSuccess)} />
            <Route path="/mobile-token-generator/failure" component={lazyComponent(MobileTokenFailure)} />
            <Redirect to="mobile-token-generator?SYS=UB" />
          </Switch>
        </div>
        <Footer />
      </BrowserRouter>
    </Provider>
  );
}

export default App;
